<template>
  <div>
    <EasyDataTable
      ref="dataTable"
      v-model:server-options="serverOptions"
      table-class-name="vue3-easy-data-table table-shadow"
      :server-items-length="serverItemsLength"
      :loading="loading"
      :headers="headers"
      :items="items"
      :prevent-context-menu-row="false"
      :fixed-header="false"
      no-hover
      alternating
      hide-footer
      @update:server-options="updateServerOptions"
    >
      <template #loading>
        <b-spinner class="mt-5" variant="success" />
      </template>
      <template #item="{ column, item }: { column: string; item: Shipment }">
        <ForwardingRow :column="column" :shipment="item" />
      </template>
    </EasyDataTable>

    <TablePagination
      v-model:server-options-ref="serverOptions"
      v-model:data-table-ref="dataTable"
      :server-items-length="serverItemsLength"
    />
  </div>
</template>

<script lang="ts">
import type { Shipment } from '@/types/Models/Shipment'
import { BSpinner } from 'bootstrap-vue-next'
import { defineComponent, onMounted, ref, watch, computed, type ComputedRef, type Ref } from 'vue'
import { useRoute } from 'vue-router'
import { makeRequestParams } from '@/services/Forwarding'
import { useShipmentStore } from '@/store/shipment'
import EasyDataTable, { type Header, type ServerOptions } from 'vue3-easy-data-table'
import ForwardingRow from '@/views/Staff/Proxy/Forwarding/Row.vue'
import TablePagination from '@/views/Components/Elements/Table/TablePagination.vue'

export default defineComponent({
  name: 'ForwardingTable',
  components: {
    BSpinner,
    ForwardingRow,
    TablePagination,
    EasyDataTable,
  },
  setup() {
    const shipmentStore = useShipmentStore()
    const route = useRoute()

    const dataTable = ref()
    const loading: ComputedRef<boolean> = computed(() => shipmentStore.shipmentsLoading)
    const items: ComputedRef<Shipment[]> = computed(() => shipmentStore.shipmentsList())
    const serverItemsLength: ComputedRef<number> = computed(() => shipmentStore.shipmentsTotal())

    const serverOptions: Ref<ServerOptions> = ref({
      page: 1,
      rowsPerPage: 50,
    })
    const headers: Header[] = [
      { text: 'ShipmentNumber', value: 'shipmentNumber' },
      { text: 'Created', value: 'createdAt' },
      { text: 'Tracking', value: 'lastTrackingEventTime' },
      { text: 'Carrier', value: 'carrier' },
      { text: 'Status', value: 'lastTrackingEventStatus' },
      { text: 'Customer', value: 'user' },
      { text: 'Recipient', value: 'recipient' },
    ]

    const loadFromServer = () => {
      shipmentStore.fetchShipments(makeRequestParams({ route, serverOptions }))
    }

    const updateServerOptions = (newOptions: ServerOptions) => {
      serverOptions.value = newOptions
    }

    onMounted(loadFromServer)

    watch(serverOptions, loadFromServer, { deep: true })

    return {
      items,
      serverItemsLength,
      loading,
      serverOptions,
      headers,
      updateServerOptions,
      dataTable,
    }
  },
})
</script>
